export const footerData = [
	{
		title: `Покупателям`,
		items: [
			{
				title: `Адреса магазинов`,
				link: `/shops/`
			},
			{
				title: `Акции`,
				link: `/sales/`
			},
			{
				title: `Гарантия`,
				link: `/guarantee/`
			},
			{
				title: `Для бизнеса`,
				link: `/b2b/`
			},
			{
				title: `Доставка и оплата`,
				link: `/delivery/`
			},
			{
				title: `Обмен и возврат`,
				link: `/return/`
			},
			{
				title: 'Подарочная карта',
				link: '/gift/'
			},
			{
				title: `Программа лояльности`,
				link: `/services/iport-card/`
			}
		]
	},
	{
		title: `С нами удобно`,
		items: [
			{
				title: `Обмен в Трейд-ин`,
				link: `/services/trade-in/`
			},
			{
				title: `Карта преимуществ iPort+`,
				link: `/services/plus/`
			},
			{
				title: `Страхование`,
				link: `/services/insurance/`
			},
			{
				title: `Сервисные центры`,
				link: `/service/`
			},
			{
				title: `Рассрочка и кредит`,
				link: `/services/credit/`
			},
			{
				title: `Пространство возможностей`,
				link: `/space/`
			},
			{
				title: 'Рассрочка от СберБанка',
				link: '/services/credit/sber/'
			},
			{
				title: 'Кредит от Т-Банка',
				link: '/services/credit/t-bank/'
			},
			{
				title: 'Оплата частями от Яндекс.Сплит',
				link: '/split/'
			},
			{
				title: 'iPort+ Care',
				link: `/services/care/`
			}
			// {
			// 	title: `iPort Upgrade`, // Archived
			// 	link: `/services/iport-upgrade/`
			// }
			// {
			//   title: `Университет iPort`,
			//   link: `/university/`,
			// },
			// {
			//   title: `Собери свой Mac`,
			//   link: `/buy-mac/`,
			// },
		]
	},

	{
		title: `Компания`,
		items: [
			{
				title: `О компании`,
				link: `/about-iport/`
			},
			{
				title: `Контакты`,
				link: `/contacts/`
			},
			{
				title: `Реквизиты`,
				link: `/bank-details/`
			},
			{
				title: `Новости`,
				link: `/news/`
			},
			{
				title: `Вакансии`,
				link: `https://nbcomgroup.ru/#job`,
				targetBlank: true
			},
			{
				title: `Блог`,
				link: '/blog/'
			}
		]
	}
]

export const subDomainFooterPage = [
	footerData[0],
	footerData[1],
	{
		title: `Компания`,
		items: [
			{
				title: `О компании`,
				link: `/about-iport/`
			},
			{
				title: `Контакты`,
				link: `/contacts/`
			},
			{
				title: `Реквизиты`,
				link: `/bank-details/`
			},
			{
				title: `Новости`,
				link: `/news/`
			},
			{
				title: `Вакансии`,
				link: `https://nbcomgroup.ru/#job`,
				targetBlank: true
			}
		]
	}
]

export const menuData = [
	{
		title: `О компании`,
		link: ``,
		items: [
			{
				title: `Контакты`,
				link: `/contacts/`
			},
			{
				link: `/b2b/`,
				title: `Для бизнеса`,
				targetBlank: true
			},
			{
				link: `/about-iport/`,
				title: `О компании`
			},
			{
				title: `Вакансии`,
				link: `https://nbcomgroup.ru/#job`,
				targetBlank: true
			},
			{
				title: `Блог`,
				link: '/blog/'
			}
		]
	},
	{
		title: `Покупателям`,
		link: ``,
		items: [
			{
				title: `Адреса магазинов`,
				link: `/shops/`
			},
			{
				title: `Акции`,
				link: `/sales/`
			},
			{
				link: `/guarantee/`,
				title: `Гарантия`
			},
			{
				title: `Доставка и оплата`,
				link: `/delivery/`
			},
			{
				link: `/return/`,
				title: `Обмен и возврат`
			},
			{
				title: 'Подарочная карта',
				link: '/gift/'
			},

			{
				link: `/services/iport-card/`,
				title: `Программа лояльности`
			}
		]
	},
	{
		title: `С нами удобно`,
		link: ``,
		items: [
			{
				title: `Обмен в Трейд-ин`,
				link: `/services/trade-in/`
			},
			{
				title: `Карта преимуществ iPort+`,
				link: `/services/plus/`
			},
			{
				title: `Страхование`,
				link: `/services/insurance/`
			},
			{
				title: `Рассрочка и кредит`,
				link: `/services/credit/`
			},
			{
				title: 'Рассрочка от СберБанка',
				link: '/services/credit/sber'
			},
			{
				title: 'Кредит от Т-Банка',
				link: '/services/credit/t-bank/'
			},
			{
				title: `Сервисные центры`,
				link: `/service/`
			},
			{
				title: 'Оплата частями от Яндекс.Сплит',
				link: '/split/'
			},
			{
				title: 'iPort+ Care',
				link: `/services/care/`
			}

			// {
			// 	title: 'Лимит на покупки',
			// 	link: `/services/limits`
			// }
			// Archived
			// {
			// 	title: `iPort Upgrade`,
			// 	link: `/services/iport-upgrade/`
			// }
		]
	}
]
export const subDomainMenuData = [
	{
		title: `О компании`,
		link: ``,
		items: [
			{
				title: `Контакты`,
				link: `/contacts/`
			},
			{
				link: `/b2b/`,
				title: `Для бизнеса`,
				targetBlank: true
			},
			{
				link: `/about/`,
				title: `О компании`
			},
			{
				title: `Вакансии`,
				link: `https://nbcomgroup.ru/#job`,
				targetBlank: true
			}
		]
	},
	menuData[1],
	menuData[2]
]
